import DataTable from "components/DataTable";
import { BannerContext } from "components/SideBar";
import React, { ReactNode, useContext } from "react";
// import { useTranslation } from "react-i18next";

interface Column {
  key: string;
  label: string;
  actions?: (row: Row) => React.ReactNode;
  excludeExport?: boolean;
}
interface Row {
  id: number;
  [key: string]: ReactNode;
}
interface DataTableProps {
  data: Row[];
  columns: Column[];
  itemsPerPage?: number;
  loading?: boolean;
  onAdd?: () => void;
  customButton?: React.ReactNode;
  buttonContent?: string;
  leftSideButtons?: React.ReactNode;
  currentPage?: number;
  totalItems?: number;
  onPageChange?: (page: number) => void;
  onItemsPerPageChange?: (itemsPerPage: number) => void;
  onSearchTermChange?: (searchTerm: string) => void;
  preAddButtons?: React.ReactNode;
}
const LeavesList: React.FC<DataTableProps> = ({
  data,
  columns,
  loading,
  onAdd,
  customButton,
  buttonContent,
  leftSideButtons,
  itemsPerPage,
  currentPage,
  totalItems,
  onPageChange,
  onItemsPerPageChange,
  onSearchTermChange,
  preAddButtons,
  ...rest
}) => {
  // const { t } = useTranslation();

  const { isBannerVisible } = useContext(BannerContext);
    
      const dynamicHeightClass = isBannerVisible
        ? "h-[calc(100vh-108px)] min-h-[300px]"
        : "h-[calc(100vh-80px)] min-h-[300px]";
  return (
    <DataTable
      data={data}
      columns={columns}
      // title={t("leave.header")}
      loading={loading}
      onAddBtnClick={onAdd}
      customButton={customButton}
      buttonContent={buttonContent}
      leftSideButtons={leftSideButtons}
      serverSidePagination
      itemsPerPage={itemsPerPage}
      currentPage={currentPage}
      totalItems={totalItems}
      onPageChange={onPageChange}
      onItemsPerPageChange={onItemsPerPageChange}
      onSearchTermChange={onSearchTermChange}
      heightClass={dynamicHeightClass}
      preAddButtons={preAddButtons}
      {...rest}
    />
  );
};
export default LeavesList;
